import { IconProps } from "../../utils/global-types/global-types";

const UserManagementIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_1084_155102)">
        <path d="M6.75 2a3.566 3.566 0 0 0-3.562 3.563c0 1.927 1.507 3.487 3.472 3.555a.6.6 0 0 1 .165 0h.053a3.554 3.554 0 0 0 3.435-3.556A3.566 3.566 0 0 0 6.75 2M10.56 11.113c-2.093-1.396-5.505-1.396-7.613 0-.952.637-1.477 1.5-1.477 2.422s.525 1.777 1.47 2.408C3.99 16.648 5.37 17 6.75 17s2.76-.352 3.81-1.057c.945-.638 1.47-1.493 1.47-2.423-.007-.922-.525-1.777-1.47-2.407M14.993 6.005a2.684 2.684 0 0 1-2.348 2.903h-.038c-.044 0-.09 0-.127.014a2.7 2.7 0 0 1-1.898-.622 3.43 3.43 0 0 0 1.125-2.85 3.5 3.5 0 0 0-.577-1.635 2.694 2.694 0 0 1 3.862 2.19"></path>
        <path d="M16.492 12.943c-.06.727-.525 1.357-1.305 1.784-.75.413-1.695.608-2.632.585.54-.487.855-1.094.915-1.74.075-.93-.368-1.822-1.253-2.534a6.2 6.2 0 0 0-1.725-.946c1.658-.48 3.743-.157 5.025.878.69.555 1.043 1.252.975 1.973"></path>
      </g>
      <defs>
        <clipPath id="clip0_1084_155102">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserManagementIcon;
